var _g, _mask, _path, _path2, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFunctionIcon4 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 143,
  height: 143,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#function-icon4_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 71.5,
  cy: 67.5,
  r: 41.5,
  fill: "#FF9078"
}))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "function-icon4_svg__b",
  maskUnits: "userSpaceOnUse",
  x: 57,
  y: 43.564,
  width: 29,
  height: 49,
  fill: "#000"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M57 43.564h29v49H57z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M63 45.564a4 4 0 0 0-4 4v36.872a4 4 0 0 0 4 4h17a4 4 0 0 0 4-4V49.564a4 4 0 0 0-4-4H63Zm18.436 2.564H61.564v34.616h19.872V48.128Z"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M61.564 48.128v-2h-2v2h2Zm19.872 0h2v-2h-2v2ZM61.564 82.744h-2v2h2v-2Zm19.872 0v2h2v-2h-2ZM61 49.564a2 2 0 0 1 2-2v-4a6 6 0 0 0-6 6h4Zm0 36.872V49.564h-4v36.872h4Zm2 2a2 2 0 0 1-2-2h-4a6 6 0 0 0 6 6v-4Zm17 0H63v4h17v-4Zm2-2a2 2 0 0 1-2 2v4a6 6 0 0 0 6-6h-4Zm0-36.872v36.872h4V49.564h-4Zm-2-2a2 2 0 0 1 2 2h4a6 6 0 0 0-6-6v4Zm-17 0h17v-4H63v4Zm-1.436 2.564h19.872v-4H61.564v4Zm2 32.616V48.128h-4v34.616h4Zm17.872-2H61.564v4h19.872v-4Zm-2-32.616v34.616h4V48.128h-4Z",
  fill: "#fff",
  mask: "url(#function-icon4_svg__b)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M61.564 48.128v-2h-2v2h2Zm19.872 0h2v-2h-2v2ZM61.564 82.744h-2v2h2v-2Zm19.872 0v2h2v-2h-2ZM61 49.564a2 2 0 0 1 2-2v-4a6 6 0 0 0-6 6h4Zm0 36.872V49.564h-4v36.872h4Zm2 2a2 2 0 0 1-2-2h-4a6 6 0 0 0 6 6v-4Zm17 0H63v4h17v-4Zm2-2a2 2 0 0 1-2 2v4a6 6 0 0 0 6-6h-4Zm0-36.872v36.872h4V49.564h-4Zm-2-2a2 2 0 0 1 2 2h4a6 6 0 0 0-6-6v4Zm-17 0h17v-4H63v4Zm-1.436 2.564h19.872v-4H61.564v4Zm2 32.616V48.128h-4v34.616h4Zm17.872-2H61.564v4h19.872v-4Zm-2-32.616v34.616h4V48.128h-4Z",
  fill: "url(#function-icon4_svg__c)",
  mask: "url(#function-icon4_svg__b)"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 71.5,
  cy: 86.5,
  r: 2.5,
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "function-icon4_svg__c",
  x1: 71.5,
  y1: 45.564,
  x2: 71.5,
  y2: 90.436,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("filter", {
  id: "function-icon4_svg__a",
  x: 0,
  y: 0,
  width: 143,
  height: 143,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 0.566083 0 0 0 0 0.470833 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})))));
export default SvgFunctionIcon4;